var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142.36,
    height: 21.401,
    viewBox: "0 0 142.36 21.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261",
    transform: "translate(-5904.512 -8228.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    "data-name": "Icon awesome-star",
    d: "M11.422.744,8.693,6.277l-6.106.89a1.338,1.338,0,0,0-.74,2.282l4.418,4.3L5.22,19.835a1.337,1.337,0,0,0,1.939,1.408l5.462-2.871,5.462,2.871a1.338,1.338,0,0,0,1.939-1.408l-1.045-6.081,4.418-4.3a1.338,1.338,0,0,0-.74-2.282l-6.106-.89L13.821.744a1.339,1.339,0,0,0-2.4,0Z",
    transform: "translate(5903.07 8228.801)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-2",
    "data-name": "Icon awesome-star",
    d: "M11.422.744,8.693,6.277l-6.106.89a1.338,1.338,0,0,0-.74,2.282l4.418,4.3L5.22,19.835a1.337,1.337,0,0,0,1.939,1.408l5.462-2.871,5.462,2.871a1.338,1.338,0,0,0,1.939-1.408l-1.045-6.081,4.418-4.3a1.338,1.338,0,0,0-.74-2.282l-6.106-.89L13.821.744a1.339,1.339,0,0,0-2.4,0Z",
    transform: "translate(5933.07 8228.801)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-3",
    "data-name": "Icon awesome-star",
    d: "M11.422.744,8.693,6.277l-6.106.89a1.338,1.338,0,0,0-.74,2.282l4.418,4.3L5.22,19.835a1.337,1.337,0,0,0,1.939,1.408l5.462-2.871,5.462,2.871a1.338,1.338,0,0,0,1.939-1.408l-1.045-6.081,4.418-4.3a1.338,1.338,0,0,0-.74-2.282l-6.106-.89L13.821.744a1.339,1.339,0,0,0-2.4,0Z",
    transform: "translate(5963.07 8228.801)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-4",
    "data-name": "Icon awesome-star",
    d: "M11.422.744,8.693,6.277l-6.106.89a1.338,1.338,0,0,0-.74,2.282l4.418,4.3L5.22,19.835a1.337,1.337,0,0,0,1.939,1.408l5.462-2.871,5.462,2.871a1.338,1.338,0,0,0,1.939-1.408l-1.045-6.081,4.418-4.3a1.338,1.338,0,0,0-.74-2.282l-6.106-.89L13.821.744a1.339,1.339,0,0,0-2.4,0Z",
    transform: "translate(5993.07 8228.801)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star-5",
    "data-name": "Icon awesome-star",
    d: "M11.422.744,8.693,6.277l-6.106.89a1.338,1.338,0,0,0-.74,2.282l4.418,4.3L5.22,19.835a1.337,1.337,0,0,0,1.939,1.408l5.462-2.871,5.462,2.871a1.338,1.338,0,0,0,1.939-1.408l-1.045-6.081,4.418-4.3a1.338,1.338,0,0,0-.74-2.282l-6.106-.89L13.821.744a1.339,1.339,0,0,0-2.4,0Z",
    transform: "translate(6023.07 8228.801)",
    fill: "#fc0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.032f95e5e976b814070afe97965bb48a.svg";
export { ForwardRef as ReactComponent };